import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '@/contexts/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export function useAccessControl() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [accessStatus, setAccessStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAccess();
  }, [user]);

  const checkAccess = async () => {
    if (!user) {
      setLoading(false);
      return;
    }

    try {
      const response = await axios.get(`${API}/auth/access-status`);
      setAccessStatus(response.data);

      // If no access and not already on trial-expired or subscribe page
      if (!response.data.has_access) {
        const currentPath = window.location.pathname;
        if (currentPath !== '/trial-expired' && currentPath !== '/subscribe' && 
            currentPath !== '/subscription-success' && currentPath !== '/subscription-cancel') {
          navigate('/trial-expired');
        }
      }
    } catch (error) {
      console.error('Error checking access:', error);
    } finally {
      setLoading(false);
    }
  };

  return {
    accessStatus,
    loading,
    hasAccess: accessStatus?.has_access || false,
    isAdmin: user?.is_admin || false,
    isTrial: accessStatus?.status === 'trial',
    isActive: accessStatus?.status === 'active',
    isExpired: accessStatus?.status === 'expired',
    daysLeft: accessStatus?.days_left || 0,
    refreshAccess: checkAccess
  };
}
